import {UserListingSortInput} from 'graphql-client/__generated/graphqlGlobalTypes';
import {UserListingCriteria} from 'tenants/admin/UserListingCriteria';
import * as net from 'util/Net';

export function getFilteredUserExportFileURL({
  userListingCriteria,
  sort,
}: {
  userListingCriteria: UserListingCriteria;
  sort: UserListingSortInput;
}): Promise<string> {
  return net.postJSONPromise({
    url: '/1/api/users:export-filtered',
    data: {
      ...userListingCriteria,
      sortKey: sort.sortKey,
      sortDirection: sort.sortDirection,
    },
  });
}

export function revokeAPIKeys({userId}: {userId: string}): Promise<string> {
  return net.deletePromise({url: `/1/api/users/${userId}/keys`});
}
